import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Hero() {
  const featuredArticles = articles.slice(0, 4);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxurious%20abalone%20closeup%20on%20dark%20stone%20surface%20with%20dramatic%20lighting%2C%20steam%20rising%2C%20ocean%20waves%20blurred%20in%20distant%20background%2C%20warm%20golden%20amber%20tones%2C%20fine%20dining%20aesthetic%2C%20cinematic%20food%20photography%20style%2C%20rich%20textures%2C%20elegant%20and%20sophisticated%20atmosphere&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="鲍鱼视频 - 从海底到餐桌的全程记录"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary-500/90 backdrop-blur-sm rounded-xl">
            <i className="ri-play-circle-fill text-2xl md:text-3xl text-background-50"></i>
          </div>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 max-w-3xl mx-auto leading-tight">
          鲍鱼养殖捕捞加工全程视频大全
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚鲍鱼养殖、捕捞、加工、烹饪全流程高清视频内容，带您深入了解鲍鱼从海底到餐桌的完整过程
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12">
          <Link
            to="/category/yangzhi"
            onClick={handleClick}
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始观看
          </Link>
          <Link
            to="/about"
            onClick={handleClick}
            className="px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap border border-background-50/30"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-3xl mx-auto">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              onClick={handleClick}
              className="group bg-background-50/10 backdrop-blur-sm rounded-xl p-3 md:p-4 text-left border border-background-50/20 hover:bg-background-50/20 transition-all cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-2">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500/80">
                  <i className="ri-play-fill text-xs text-background-50"></i>
                </div>
                <span className="text-xs text-background-50/70">{article.duration}</span>
              </div>
              <p className="text-xs md:text-sm text-background-50 font-medium line-clamp-2 leading-snug group-hover:text-primary-300 transition-colors">
                {article.title}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}